import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tienda, setTienda] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const optionals = producto?.optionals || []; // Asume que el producto trae un arreglo 'optionals'
    const [opcionalesParseados, setOpcionalesParseados] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const optionalsMode = producto?.optionalsMode ? Number(producto.optionalsMode) : 0;
    /*
  const productosJugos = [78, 79, 80, 81, 82, 83, 84, 85, 86, 87];
  
  const productosAguaRefrescosGaseosas = [51, 52, 53, 54, 55, 56, 57, 68, 69, 70];
  
  const productosSundae = [58, 59, 60];
  
  const productosBuffaloAcevichado = [88, 90, 91];
  
  const productosBroaster = [67, 77];
  
  const productosCono = [93, 94, 95, 96, 97, 98];
  */

     /*   const optionalLimits =
        productosJugos.includes(producto?.idProducto)
            ? {
                "Estado": 1,
                "Dulzor": 1
            }
            : producto?.idProducto === 99
                ? {
                    "Sabor": 2
                }
                : productosAguaRefrescosGaseosas.includes(producto?.idProducto)
                    ? {
                        "Estado": 1
                    }
                    : productosSundae.includes(producto?.idProducto)
                        ? {
                            "1 topping gratis": 1,
                            "Base del sundae": 1
                            // "Toppings extra": ilimitado
                        }
                        : productosBuffaloAcevichado.includes(producto?.idProducto)
                            ? {
                                "Búfalo": 1,
                                "Acevichado": 1,
                                "Extra": 1
                            }
                            : productosBroaster.includes(producto?.idProducto)
                                ? {
                                    "Ensalada": 1
                                }
                                : productosCono.includes(producto?.idProducto)
                                    ? {
                                        "Gaseosa": 1,
                                        "Estado": 1,
                                        ...([95, 97].includes(producto?.idProducto)
                                            ? { "Extra": 1 }
                                            : {})
                                    }
                                    : {};  */
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();
    const categoriasInputRef = useRef(null);
    const [fixedCategories, setFixedCategories] = useState(false);
    const [subcategorias, setSubCategorias] = useState([]);
    const [debugMessage, setDebugMessage] = useState(""); // Mensaje a mostrar
    const [isDebugModalOpen, setIsDebugModalOpen] = useState(false); // Control modal
    useEffect(() => {
        cargarProductos();
        cargarTienda();
        cargarFavoritos();
        cargarCategoria()
        cargarSubCategoria()

    }, []);
    useEffect(() => {

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const showDebugMessage = (message) => {
        setDebugMessage(message);
        setIsDebugModalOpen(true);
    };
    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSubCategorias(data.subcategorias || []);
                console.log(data.subcategorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };
    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                console.log(data.productos)
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
                setLoading(true);
            });
    };


    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);


        let parsedOptionals = [];
        if (product?.optionals) {
            try {
                let cleaned = product.optionals.replace(/^"|"$/g, "").replace(/\\"/g, '"');
                parsedOptionals = JSON.parse(cleaned);
                console.log("Optionals parseados:", parsedOptionals);
            } catch (e) {
                console.error("Error parseando optionals:", e);
                parsedOptionals = [];
            }
        }

        // ⚡ Guardar opcionales parseados completos
        setOpcionalesParseados(parsedOptionals);

        // ⚡ Para checkboxes, solo los títulos
        const optionalsStrings = parsedOptionals.map(opt => opt.titulo);
        console.log("Optionals para checkbox:", optionalsStrings);
        const initialSelected = {};

        parsedOptionals.forEach((opt) => {
            initialSelected[opt.titulo] = [];
        });

        setSelectedItems(initialSelected);

    }, [idProducto, productos]);

    const handleCheckboxChange = (grupoTitulo, item) => {
        setSelectedItems(prev => {
            const copy = { ...prev };

            // Obtener máximo permitido
           // const limit = optionalLimits[grupoTitulo] || 999;

            // Convertimos a array siempre
            let current = copy[grupoTitulo] || [];

            // 🔥 Si antes era string (modo antiguo)
            if (!Array.isArray(current)) {
                current = current ? [current] : [];
            }

            // Si ya existe -> quitar
            if (current.includes(item)) {
                copy[grupoTitulo] = current.filter(i => i !== item);
                return copy;
            }

            // 🔥 Si el límite es 1, reemplazar automáticamente
            //if (limit === 1) {
               // copy[grupoTitulo] = [item];
               // return copy;
           // }

            // 🔥 Si llegó al límite no agregar más
            //if (current.length >= limit) {
              //  return copy;
            //}

            // Agregar nuevo item
            copy[grupoTitulo] = [...current, item];

            return copy;
        });
    };




    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .then(() => console.log('Contenido compartido correctamente'))
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = tienda[0]?.telefono;
        const removeAccents = (str) => {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza y elimina acentos
        };

        const title = encodeURIComponent(removeAccents(producto?.titulo)?.replace(/\s+/g, '-'));

        const formattedPrice = Number(producto?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        // Verifica si hay items seleccionados
        const selectedItemsText = Object.entries(selectedItems)
            .map(([grupo, value]) =>
                Array.isArray(value)
                    ? `${grupo}: ${value.join(', ')}`
                    : value
                        ? `${grupo}: ${value}`
                        : ""
            )
            .filter(Boolean)
            .join(' | ');

        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${title}*\n     ${selectedItemsText}\n     ${moneda} ${formattedPrice}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };


    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };




    const addToCart = () => {
        if (producto) {
            if (producto.stock < 1) {
                toast.error('No hay stock', { autoClose: 400 });
                return;
            }

            const cart = JSON.parse(localStorage.getItem('cart')) || [];

            const existingItemIndex = cart.findIndex(
                item => item.idProducto === producto.idProducto
            );

            // 🔥 OPCIONALES CON PRECIO
            const itemsToAdd = Object.entries(selectedItems).flatMap(
                ([grupo, value]) => {
                    if (!value) return [];

                    if (Array.isArray(value)) {
                        return value.map(item => {
                            const opcion = opcionalesParseados
                                .find(g => g.titulo === grupo)
                                ?.items.find(i => i.nombre === item);

                            return {
                                grupo,
                                item,
                                precio: opcion?.precio || 0
                            };
                        });
                    }

                    const opcion = opcionalesParseados
                        .find(g => g.titulo === grupo)
                        ?.items.find(i => i.nombre === value);

                    return [{
                        grupo,
                        item: value,
                        precio: opcion?.precio || 0
                    }];
                }
            );

            // 🔥 SUMA DE EXTRAS
            const extrasTotal = itemsToAdd.reduce(
                (acc, i) => acc + Number(i.precio || 0),
                0
            );

            const precioFinal =
                Number(producto.precio || 0) + extrasTotal;

            if (existingItemIndex !== -1) {

                const existingItem = cart[existingItemIndex];

                const updatedItems = [
                    ...existingItem.items,
                    ...itemsToAdd
                ];

                const updatedCantidad =
                    existingItem.cantidad + cantidad;

                const existingExtras =
                    Number(existingItem.extras || 0);

                cart[existingItemIndex] = {
                    ...existingItem,
                    items: updatedItems,
                    cantidad: updatedCantidad,
                    precio: Number(producto.precio || 0),

                    extras:
                        existingExtras + extrasTotal,

                    precioFinal:
                        Number(producto.precio || 0) +
                        existingExtras +
                        extrasTotal
                };

            } else {

                cart.push({
                    idProducto: producto.idProducto,
                    titulo: producto.titulo,
                    items: itemsToAdd,
                    cantidad,

                    precio: Number(producto.precio || 0),

                    extras: extrasTotal,

                    precioFinal
                });
            }

            localStorage.setItem('cart', JSON.stringify(cart));

            toast.success('Producto agregado', { autoClose: 400 });

            setTimeout(() => window.location.reload(), 600);
        }
    };



    const incrementCantidad = () => {
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };


    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            // Si el producto no está en favoritos, lo agregamos
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto agregado a favoritos');

        } else {
            // Si el producto está en favoritos, lo eliminamos
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto eliminado de favoritos');
        }
    };



    if (!producto) {
        return <DetailLoading />;
    }


    return (


        <div className="detail">

            <Modal
                open={isDebugModalOpen}
                onClose={() => setIsDebugModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <div style={{ padding: "20px" }}>
                    <h3>Depuración</h3>
                    <p style={{ whiteSpace: "pre-wrap" }}>{debugMessage}</p>
                    <button className="btn" onClick={() => setIsDebugModalOpen(false)}>Aceptar</button>
                </div>
            </Modal>

            <ToastContainer />
            <div className={`deFlexDetail ${fixedCategories ? 'fixedHeader' : ''}`} ref={categoriasInputRef}>
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>

                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>


            </div>
            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"} >
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }} // Cambia el valor de 'delay' según tus preferencias
                        pagination={{ clickable: true, }}
                        onSwiper={(swiper) => {
                            console.log(swiper);
                            swiperRef.current = swiper;
                        }}

                    >

                        {
                            producto.imagen1 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen1}
                                            alt={producto.titulo}
                                            className="imagen1"
                                            onClick={() => {
                                                setModalImage(producto.imagen1);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }

                        {
                            producto.imagen2 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen2}
                                            alt={producto.titulo}
                                            className="imagen2"
                                            onClick={() => {
                                                setModalImage(producto.imagen2);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen3 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen3}
                                            alt={producto.titulo}
                                            className="img"
                                            onClick={() => {
                                                setModalImage(producto.imagen3);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen4 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen4}
                                            alt={producto.titulo}
                                            className="imagen4"
                                            onClick={() => {
                                                setModalImage(producto.imagen4);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                    </Swiper>
                </SwiperSlide>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {
                            categorias
                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                .map(categoriaFiltrada => (
                                    <h4>  <FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}
                                        {subcategorias
                                            ?.filter(subcategoriaFiltrada => subcategoriaFiltrada.idSubCategoria === producto.idSubCategoria)
                                            ?.map(subcategoriaFiltrada => (
                                                <>
                                                    {` >`}  {subcategoriaFiltrada?.subcategoria}
                                                </>
                                            ))
                                        }
                                    </h4>

                                ))
                        }
                        {producto.stock === 1 ? (
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>Stock</h4>
                        ) : producto.stock <= 0 ? (
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '0px 10px', borderRadius: '6px' }}>Agotado</h4>
                        ) : (

                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>{producto.stock}</h4>
                        )}
                    </div>

                    <div className='deFLexPrice'>
                        <h5 className="price">
                            {moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}

                        </h5>

                        {
                            (producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined) && (
                                <h5 className='precioTachadoDetail'> {moneda} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            )
                        }


                    </div>
                    <p>{producto.descripcion}</p>

                    {/* === OPCIONALES === */}
                    {opcionalesParseados.length > 0 && (
                        <div style={{ marginTop: "20px" }}>

                            <h3
                                style={{
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                    color: "#5c5959",
                                    fontSize: "18px" // 🔥 un poco más pequeño
                                }}
                            >
                                Opciones disponibles:
                            </h3>

                            {opcionalesParseados.map((grupo, index) => (
                                <div
                                    key={index}
                                    style={{
                                        background: "#f7f7f7",
                                        padding: "10px",
                                        borderRadius: "6px",
                                        marginBottom: "15px"
                                    }}
                                >
                                    <h4
                                        style={{
                                            fontWeight: "bold",
                                            marginBottom: "8px",
                                            color: "#5c5959"
                                        }}
                                    >
                                        {grupo.titulo}
                                    </h4>

                                    {grupo.items.map((item, idx) => (
                                        <label
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "6px",
                                                cursor: "pointer",
                                                color: "#5c5959"
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={(selectedItems?.[grupo.titulo] || []).includes(item.nombre)}
                                                onChange={() => handleCheckboxChange(grupo.titulo, item.nombre)}
                                            />

                                            {item.nombre}{" "}
                                            {item.precio ? `(+${moneda} ${item.precio})` : ""}
                                        </label>
                                    ))}
                                </div>
                            ))}

                        </div>
                    )}


                    <div className='deFlexCart'>
                        <button onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button onClick={incrementCantidad}>+</button>
                    </div>
                    <div className='deFlexGoTocart'>
                        <button onClick={addToCart} className='btnAdd'>
                            Agregar <FontAwesomeIcon icon={faShoppingCart} />
                        </button>
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>

    )
}





